exports.install = function (Vue, options) {
	Vue.prototype.api.Screenshot = {
		getList(value={})//获取录像机截图列表数据
		{
			if(value.qaedasId==null)
			{
				value.qaedasId=Vue.prototype.getCookie("jdid");
			}
			return Vue.prototype.axiosget("/api/Screenshot/getList",value)
			.then((response)=>{
				return response;
			});
		}
	};
}
